// Firebase RTDB read/write for engine state
// Expects firebase to be available globally (loaded by host app)
// All paths are cert-scoped via certPath() or user-global via globalPath()

let _db = null;

export function initStore(firebaseApp) {
  _db = firebaseApp.database();
}

export function getDb() {
  if (!_db) throw new Error('Engine store not initialized. Call initStore(firebaseApp) first.');
  return _db;
}

// Path helpers — cert-scoped vs user-global
export function certPath(userId, certId, subpath) {
  return 'engine/users/' + userId + '/certs/' + certId + (subpath ? '/' + subpath : '');
}

export function globalPath(userId, subpath) {
  return 'engine/users/' + userId + '/global' + (subpath ? '/' + subpath : '');
}

// Legacy flat path (for migration reads only)
export function legacyPath(userId, subpath) {
  return 'engine/users/' + userId + (subpath ? '/' + subpath : '');
}

export async function read(path) {
  const snap = await getDb().ref(path).once('value');
  return snap.val();
}

export async function write(path, data) {
  await getDb().ref(path).set(data);
}

export async function push(path, data) {
  const ref = await getDb().ref(path).push(data);
  return ref.key;
}

export async function update(path, data) {
  await getDb().ref(path).update(data);
}
